// extracted by mini-css-extract-plugin
export default {"cards":"MainPage_cards__VCh9R","teaser":"MainPage_teaser__dXfO1"};